export default __webpack_public_path__ + "assets/images/af97f1689ff6671a603c9ee8a6919c13.svg";